import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";


import { useAppMeta } from "hooks";
import ShipmentAddCollectForm from "./ShipmentComponents/ShipmentAddCollectForm";
import { useAddShipmentAndCollectMutation } from "store/services/shipmentApi";

const ShipmentAddCollectCreateScreen = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    
    const isCollect = searchParams.get("addAndCollect") === "true";
    
    const basePath = "/app/crm/shipment";

    const breadcrumbs = [
        {
            title: "Shipment",
            path: "/app/crm/shipment/list",
        },
        {
            title: "Add & Collect",
            path: "",
        },
    ];

    const [createShipment, { isLoading: creatingShipment }] =
        useAddShipmentAndCollectMutation();


    // Methods
    const handleAddShipment = async (data) => {
        try {
            const payload = {
                ...data,
                ...(isCollect && {
                    collectionData: {
                        actualPickupTime: new Date().toISOString(),
                        status: "Completed",
                    },
                }),
            };
            const { shipment: { _id } } = await createShipment(payload).unwrap(); toast.success(
                isCollect ? "Shipment Created and Collected!" : "Shipment Created!"
            );
            navigate(`${basePath}/${_id}/detail`);
        } catch (error) {
            toast.error(
                error?.data?.message ?? error.message ?? "Could not create shipment!"
            );
        }
    };
    useAppMeta(isCollect ? "New Shipment & Collection" : "New Shipment");

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipment}>
            <BreadcrumbLayout.Paper>
                <ShipmentAddCollectForm
                    isBusy={creatingShipment}
                    onSubmit={handleAddShipment}
                    isCollect={isCollect}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default ShipmentAddCollectCreateScreen;
